import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import ArchiveIcon from '@mui/icons-material/Archive';

const CaseEditList = (props) => {

  const data = Object.values(props.data || {});

  const handleEditClick = props.handleEditClick
  // const handleDelete = props.handleDelete
  const handleArchive = props.handleArchive?props.handleArchive:()=>{}
  const showEdit = props.showEdit ? props.showEdit : false;
  const showDelete = props.showDelete ? props.showDelete : false;

  if (data.length === 0) {
    return <div></div>
  }

  return (

    <List>
      {data.map(( this_case ) => (
        <React.Fragment key={this_case.caseID + "-DUMMY"}>
          <ListItem key={this_case.caseID}>
            <ListItemText primary={this_case.caseName} secondary={this_case.status} />
            <ListItemSecondaryAction>
              {showEdit && this_case.status === "ACTIVE" &&
                <IconButton edge="end" aria-label="edit" onClick={() => handleEditClick(this_case)}>
                  <EditIcon />
                </IconButton>
              }
              {showDelete && this_case.status === "ACTIVE" &&
              <IconButton edge="end" aria-label="archive" onClick={() => handleArchive(this_case)}>
                <ArchiveIcon />
              </IconButton>
              }
            </ListItemSecondaryAction>
          </ListItem>
          <Divider></Divider>
        </React.Fragment>
      ))}
    </List>


  );
};

export default CaseEditList;